import { render } from "./FeaturingItem.vue?vue&type=template&id=56aec03e"
import script from "./FeaturingItem.vue?vue&type=script&lang=js"
export * from "./FeaturingItem.vue?vue&type=script&lang=js"

import "./FeaturingItem.vue?vue&type=style&index=0&id=56aec03e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__